import { EnumsInterface } from "@/interfaces/EnumsInterface";

const SyncStatusOptions:EnumsInterface[] = [
    {id: 0, value: 0, label: "To Sync"},
    {id: 1, value: 1, label: "Synced"},
    {id: 2, value: 2, label: "To Resolved"},
]

export default SyncStatusOptions